/**
 * @desc 新增设备
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/equipment/add',
    data,
  });
}

export function mock(
  data: defs.TheNewManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/equipment/add',
    data,
  });
}
